export default __webpack_public_path__ + "static/media/extentTest.183cdaaa.svg";